import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getIsImpersonating} from '../../../../store/data/dataSelectors';
import {ImpersonationModeBanner} from './impersonationModeBanner';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isImpersonating: getIsImpersonating,
}));

export const ImpersonationModeBannerContainer = connect(mapStateToProps)(ImpersonationModeBanner);
